export type DownloadOutcome = 'downloaded' | 'opened'

const EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'webp', 'svg']

const extensionFromUrl = (url: string) => {
  const path = url.split(/[?#]/)[0]
  const guess = path.split('.').pop()?.toLowerCase()
  return guess && EXTENSIONS.includes(guess) ? guess : undefined
}

const extensionFromType = (type: string) => {
  const guess = type.split('/')[1]?.split('+')[0]?.toLowerCase()
  return guess && EXTENSIONS.includes(guess) ? guess : undefined
}

export const slugifyFileName = (name: string) =>
  name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase() || 'plik'

// TO DO!!! sprawdzić na realnych URL-ach, czy storage z mapami wystawia CORS dla
// domeny panelu — bez tego zawsze wpadamy w gałąź 'opened' (plik nie zapisze się
// pod naszą nazwą); alternatywa to Content-Disposition: attachment po stronie hostingu
export const downloadFile = async (
  url: string,
  baseName: string,
): Promise<DownloadOutcome> => {
  try {
    const response = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    const blob = await response.blob()
    const extension =
      extensionFromUrl(url) ?? extensionFromType(blob.type) ?? 'pdf'
    const href = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = href
    link.download = `${slugifyFileName(baseName)}.${extension}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(href), 10000)
    return 'downloaded'
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer')
    return 'opened'
  }
}
